<template>
  <div>
    <div class="d-flex flex-wrap">
      <div class="w-50 position-relative">
        <label class="form-label font-weight-bold">Select Identity:</label>
        <v-select
          v-model="identitySelected"
          :options="options"
          label="name"
          group-label="group"
          group-values="items"
          style="width: 100%"
          class="select-video-input"
          placeholder="Choose Identity"
          :clearable="false"
          :searchable="false"
          :selectable="isOptionSelectable"
          @input="handleMapVideoToIdentity"
        >
          <template #open-indicator="{ attributes }">
            <span v-bind="attributes">
              <feather-icon
                icon="ChevronDownIcon"
                size="13"
              />
            </span>
          </template>
          <template #selected-option="{ logo, name }">
            <img
              class="mr-50"
              style="width: 26px; height: auto"
              :src="logo || require('@/assets/images/pages/campaign/lg-indentity-default.png')"
            >
            <div
              v-b-tooltip.hover.top.v-light.html
              class="d-flex flex-column content-ad-account w-100"
              :title="name ? name : '--'"
            >
              <span
                class="wrap-content"
                style="margin-right: 4px"
              >{{ name }}</span>
            </div>
          </template>
          <template #option="{ logo, name, header }">
            <span
              v-if="!!header"
            >{{ header }}</span>
            <div
              v-else
              class="d-flex align-items-center ml-1"
            >
              <img
                class="mr-50"
                style="width: 26px;height: auto"
                :src="logo || require('@/assets/images/pages/campaign/lg-indentity-default.png')"
              >
              <span>{{ name }}</span>
            </div>
          </template>
        </v-select>
        <small
          v-show="videosSelected.length > 0 && !identitySelected"
          class="text-danger position-absolute"
          style="bottom: -20px"
        >
          The identity is required.
        </small>
      </div>
      <div class="w-50 pl-2 position-relative select-ad-text">
        <label class="form-label font-weight-bold">Text:</label>
        <v-select
          v-model="textName"
          ref="textSelect"
          :class="{ 'is-searching': !!currentAdTextSearch }"
          multiple
          taggable
          push-tags
          placeholder="Enter text"
          label="title"
          @search="onTextSearch"
          @search:blur="onTextBlur"
          @input="handleEnterAdText"
        />
        <small
          v-if="videosSelected.length > 0 && textName && textName.length === 0"
          class="text-danger position-absolute"
          style="bottom: -20px"
        >
          The text is required.
        </small>
      </div>
    </div>
    <div class="d-flex justify-content-end align-items-center my-1">
      <btn-loading
        variant-convert="btn-submit-outline"
        pill
        class="d-flex align-items-center mr-1"
        style="height: 32px"
        @click="syncHerotiveVideo"
      >
        <feather-icon
          class="button__icon mr-50 cursor-pointer"
          icon="PlusIcon"
        />
        <span>Add videos from Herotive</span>
      </btn-loading>
      <b-button
        size="sm"
        variant="outline-primary width-max"
        pill
        @click="handelClearVideo"
      >
        Clear {{ videosSelected.length }} selection
      </b-button>
    </div>
    <div
      ref="videoScrollContainer"
      style="overflow-y: scroll"
      :style="isTikTokPlacement ? 'height: calc(100vh - 553px)' : 'height: calc(100vh - 505px)'"
      @scroll="onScroll"
    >
      <div
        v-if="loadingVideo"
        class="d-flex justify-content-center"
      >
        <b-spinner
          variant="secondary"
          small
        />
      </div>
      <div v-else-if="listVideos.length > 0">
        <div class="video-grid">
          <div
            v-for="video in listVideos"
            :key="video.video_id"
            class="video-card position-relative"
            :class="{ 'selected': isVideoSelected(video) }"
            @click="toggleVideo(video)"
          >
            <div
              class="video-thumbnail"
              @mouseenter="onHoverStart(video)"
              @mouseleave="onHoverEnd"
            >
              <!-- Dark overlay for disabled videos -->
              <div
                v-if="video.isDisable"
                class="video-overlay"
              />

              <!-- Small checkbox indicator -->
              <div
                class="select-checkbox"
                :class="{ checked: isVideoSelected(video), 'cursor-not-allowed': video.isDisable }"
              >
                <b-spinner
                  v-if="loadingSelectedVideoId.includes(video.video_id)"
                  variant="secondary"
                  small
                />
                <feather-icon
                  v-if="isVideoSelected(video)"
                  icon="CheckIcon"
                  size="14"
                  class="text-white"
                />
              </div>

              <template v-if="playingVideoId === video.video_id">
                <div
                  class="position-relative"
                  style="width: 100%; height: 100%;"
                >
                  <video
                    :ref="`video-${video.video_id}`"
                    :src="video.preview_url"
                    autoplay
                    :muted="videoMutedStates[video.video_id] !== false"
                    loop
                    playsinline
                    style="width: 100%; height: 100%; object-fit: cover;"
                  />
                  <feather-icon
                    :icon="videoMutedStates[video.video_id] !== false ? 'VolumeXIcon' : 'Volume2Icon'"
                    size="24"
                    class="video-sound-icon cursor-pointer"
                    @click.stop="toggleVideoSound(video.video_id)"
                  />
                </div>
              </template>
              <template v-else>
                <img
                  :src="video.video_cover_url"
                  class="thumbnail-image"
                >
              </template>
              <!-- Remove full overlay selection -->
            </div>
          </div>
        </div>
        <!-- Load More Loading -->
        <div
          v-if="loadingMore"
          class="d-flex justify-content-center py-3"
        >
          <b-spinner
            variant="secondary"
            small
          />
        </div>
      </div>

      <!-- No Videos State -->
      <div
        v-else-if="listVideos.length === 0"
        class="text-center py-4"
      >
        <b-img
          alt="No account"
          class="img"
          :src="require('@/assets/images/common/no-data-table.svg')"
        />
      </div>
    </div>

  </div>
</template>
<script>
/* eslint-disable no-underscore-dangle,camelcase */
import {
  BButton, BImg, BSpinner, VBTooltip,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { createNamespacedHelpers } from 'vuex'
import BtnLoading from '@/layouts/components/BtnLoading.vue'
import { toastification } from '@core/mixins/toast'

const { mapGetters, mapActions } = createNamespacedHelpers('campaign')

export default {
  components: {
    BtnLoading,
    BSpinner,
    BImg,
    BButton,
    vSelect,
  },

  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },

  mixins: [toastification],

  props: {
    campaigns: {
      type: Array,
      default: () => [],
      required: true,
    },

    currentAdGroup: {
      type: Object,
      default: () => {
      },
    },

    selectedAd: {
      type: Object,
      default: () => {
      },
    },

    allVideos: {
      type: Array,
      default: () => [],
    },

    selectedVideos: {
      type: Array,
      default: () => [],
    },

    selectedVideosCreative: {
      type: Array,
      default: () => [],
    },

    identityOptions: {
      type: Array,
      default: () => [],
    },

    isTikTokPlacement: {
      type: Boolean,
      default: false,
    },

    loadingVideo: {
      type: Boolean,
      default: false,
    },

    loadingMore: {
      type: Boolean,
      default: false,
    },

    hasMore: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      playingVideoId: null,
      videoMutedStates: {},
      identitySelected: null,
      savedScrollTop: 0,
      waitingForLoadMore: false,
      videosSelected: [],
      textName: [],
      currentAdTextSearch: '',

      loadingSelectedVideoId: [],
    }
  },

  computed: {
    ...mapGetters(['videoSyncInfo', 'listThumbnailVideoCreative', 'loading', 'message', 'status']),
    options() {
      const tiktokIdentity = [{ header: 'TikTok Account', disabled: true }, ...this.identityOptions.filter(identity => identity.identityType !== 'CUSTOMIZED_USER') || []]
      const customIdentity = [{ header: 'Custom identities', disabled: true }, ...this.identityOptions.filter(identity => identity.identityType === 'CUSTOMIZED_USER') || []]
      if (this.isTikTokPlacement) {
        return [...tiktokIdentity, ...customIdentity]
      }
      return customIdentity
    },

    listVideos() {
      return this.allVideos
    },
    isValidForApply() {
      const hasSelection = this.videosSelected.length > 0
      const hasIdentity = !!this.identitySelected
      const hasText = this.textName?.length > 0
      return !hasSelection || (hasIdentity && hasText)
    },
  },

  watch: {
    selectedVideosCreative: {
      handler(val) {
        if (val) {
          this.videosSelected = val
          if (this.selectedVideosCreative.length > 0) {
            this.identitySelected = this.identityOptions.find(item => item.value === this.selectedVideosCreative[0].identity_id)
            this.textName = this.selectedVideosCreative[0].ad_text
          }
        }
      },
      deep: true,
      immediate: true,
    },

    selectedAd: {
      handler(val) {
        if (val) {
          this.initData()
        }
      },
      deep: true,
      immediate: true,
    },

    // Restore scroll after load-more completes
    loadingMore(newVal, oldVal) {
      if (oldVal === true && newVal === false && this.waitingForLoadMore) {
        this.$nextTick(() => {
          if (this.$refs.videoScrollContainer) {
            this.$refs.videoScrollContainer.scrollTop = this.savedScrollTop
          }
          this.waitingForLoadMore = false
        })
      }
    },
    identitySelected() {
      this.$emit('validation-state-changed', this.isValidForApply)
    },
    textName() {
      this.$emit('validation-state-changed', this.isValidForApply)
    },
  },

  methods: {
    ...mapActions(['syncVideoToAdAccount', 'getThumbnailVideoCreative']),

    isOptionSelectable(option) {
      return !option.disabled
    },

    initData() {
      if (this.selectedVideosCreative.length > 0) {
        this.identitySelected = this.identityOptions.find(item => item.value === this.selectedVideosCreative[0].identity_id)
        this.textName = this.selectedVideosCreative[0].ad_text
      } else {
        this.identitySelected = null
        this.textName = []
      }
    },

    onHoverStart(video) {
      this.playingVideoId = video.video_id
    },

    onHoverEnd() {
      this.playingVideoId = null
    },

    toggleVideoSound(videoId) {
      // Toggle muted state for this video
      this.$set(this.videoMutedStates, videoId, this.videoMutedStates[videoId] === false)
      // Update the video element's muted property
      const videoElement = this.$refs[`video-${videoId}`]
      if (videoElement && videoElement[0]) {
        videoElement[0].muted = this.videoMutedStates[videoId] !== false
      }
    },

    isVideoSelected(video) {
      return this.videosSelected.some(v => {
        // Handle both raw video objects and processed video objects
        const videoId = v?.video_info?.video_id || v?.video_id
        return videoId === video.video_id
      })
    },

    onScroll(event) {
      const { target } = event
      const { scrollTop, scrollHeight, clientHeight } = target

      // Check if scrolled to bottom (with 100px threshold)
      const isNearBottom = scrollTop + clientHeight >= scrollHeight - 100

      if (isNearBottom && this.hasMore && !this.loadingMore && !this.loading) {
        // Save current position to restore after items append
        this.savedScrollTop = this.$refs.videoScrollContainer ? this.$refs.videoScrollContainer.scrollTop : 0
        this.waitingForLoadMore = true
        this.$emit('fetchListVideo', true)
      }
    },

    async syncHerotiveVideo() {
      this.$emit('openSyncHerotiveVideoModal')
    },

    handelClearVideo() {
      this.videosSelected = []
      this.$emit('toggle-video-selection', [])
      this.$emit('validation-state-changed', this.isValidForApply)
    },

    onTextSearch(search) {
      this.currentAdTextSearch = (search || '').trim()
    },

    onTextBlur() {
      const value = (this.currentAdTextSearch || '').trim()
      this.textName = [...new Set(this.textName.map(v => v.trim()))]

      if (!value) return
      const exists = this.textName.some(item => (typeof item === 'string' ? item : item?.title) === value)

      if (!exists) {
        this.textName = [...this.textName, value]
        this.$emit('validation-state-changed', this.isValidForApply)
      }

      if (this.$refs.textSelect) {
        this.$refs.textSelect.search = ''
      }
      this.currentAdTextSearch = ''
      this.handleEnterAdText()
    },

    async handleEnterAdText() {
      this.handleMapVideoToIdentity()

      this.$nextTick(() => {
        if (this.$refs.textSelect && this.$refs.textSelect.searchEl) {
          this.$refs.textSelect.searchEl.focus()
        }
      })
    },

    handleMapVideoToIdentity() {
      // Keep identity/text when no videos selected; don't emit reset upstream
      if (!this.videosSelected || this.videosSelected.length === 0) {
        this.$emit('validation-state-changed', this.isValidForApply)
        this.$emit('toggle-video-selection', [])
        return
      }

      const videosWithIdentity = this.videosSelected.map(video => ({
        ad_text: this.textName,
        // ad_material_id: video.ad_material_id || video?.smartPlusPayload?.adMaterialId,
        ad_format: video?.ad_format || 'SINGLE_VIDEO',
        identity_authorized_bc_id: this.identitySelected?.bcId || '',
        identity_id: this.identitySelected?.value || '',
        identity_type: this.identitySelected?.identityType || '',
        image_info: video?.image_info || [{
          web_uri: video?.thumbnailId,
        }],
        video_info: {
          file_name: video.video_info?.file_name || video.file_name,
          video_id: video.video_info?.video_id || video.video_id,
        },
        material_operation_status: 'DISABLE',
      }))
      this.$emit('toggle-video-selection', videosWithIdentity)
    },

    async toggleVideo(video) {
      if (this.loadingSelectedVideoId.includes(video.video_id)) return

      if (!this.loadingSelectedVideoId.includes(video.video_id)) {
        this.loadingSelectedVideoId = [...this.loadingSelectedVideoId, video.video_id]
      }

      try {
        const index = this.videosSelected.findIndex(v => {
          const videoId = v?.video_info?.video_id || v?.video_id
          return videoId === video.video_id
        })

        if (index > -1) {
          this.videosSelected.splice(index, 1)
        } else {
          const params = {
            advertiserId: this.$route.query?.advertiserId,
            videoId: video.video_id,
            page: 1,
            size: 1,
          }
          await this.getThumbnailVideoCreative(params)
          if (this.status) {
            const videoWithThumbnail = {
              ...video,
              thumbnailId: this.listThumbnailVideoCreative.content?.[0]?.id,
            }
            this.videosSelected.push(videoWithThumbnail)
          } else {
            this.toastFailure('Select video failed. Please try again.')
          }
        }

        this.handleMapVideoToIdentity()
        this.$emit('validation-state-changed', this.isValidForApply)
      } finally {
        this.loadingSelectedVideoId = this.loadingSelectedVideoId.filter(id => id !== video.video_id)
      }
    },
  },
}
</script>
<style lang="scss" >
.select-ad-text {
  .v-select .vs__dropdown-menu {
    display: none !important;
  }

  /* Show dropdown only while searching */
  .v-select.is-searching .vs__dropdown-menu {
    display: block !important;
  }

  .vs__selected-options {
    width: 100%;
    overflow-y: scroll;
    max-height: 60px;

    .vs__selected {
      color: #000000;
      border: 0 solid rgba(60, 60, 60, .26);
      background: rgba(22, 33, 62, .05);

      position: relative;
      padding-right: 22px !important;
      max-width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .vs__deselect {
      position: absolute;
      right: 0;
      flex: 0 0 auto;
      padding-left: 6px;
      padding-right: 6px;
      background: #f5f5f6;
    }
  }
}
</style>
<style lang="scss" scoped>
.video-card {
  .sync-button {
    opacity: 0;
    transition: opacity 0.2s ease;
  }

  &:hover .sync-button {
    opacity: 1;
  }
}

.video-thumbnail {
  position: relative;

  .video-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    z-index: 1;
    pointer-events: none; /* Allow video to still play underneath */
  }

  .select-checkbox {
    z-index: 2; /* Above overlay */
  }
}

.video-sound-icon {
  position: absolute;
  bottom: 8px;
  right: 8px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  padding: 4px;
  color: white;
  z-index: 3;
  transition: background-color 0.2s ease;

  &:hover {
    background: rgba(0, 0, 0, 0.8);
  }
}
</style>
